import { __makeTemplateObject } from "tslib";
import PropTypes from 'prop-types';
import styled from '@marvelapp/styled';
import Flex from '../Flex';
var FlexWrap = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-wrap: wrap;\n  margin-left: ", ";\n  width: ", ";\n"], ["\n  flex-wrap: wrap;\n  margin-left: ", ";\n  width: ", ";\n"])), function (_a) {
    var space = _a.space;
    return "-".concat(space, "px");
}, function (_a) {
    var space = _a.space;
    return "calc(100% + ".concat(space * 2, "px)");
});
FlexWrap.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    space: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.array,
    ]),
};
export default FlexWrap;
var templateObject_1;
